import styles from "./LanguageSwitch.module.css";
import { labels } from "./blogLanguage";

const LanguageSwitch = ({ language, onLanguageChange }) => (
  <div className={styles.switch} role="group" aria-label={labels[language].language}>
    {[["en", "English"], ["ko", "한국어"]].map(([value, label]) => (
      <button
        key={value}
        type="button"
        lang={value}
        aria-pressed={language === value}
        onClick={() => onLanguageChange(value)}
      >
        {label}
      </button>
    ))}
  </div>
);

export default LanguageSwitch;
